import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import { Alert } from "antd";
// GraphQL
import { GET_PAYMENT_TYPE } from "graphql/queries/GetProfile";
import {
  isRateLimitError,
  RATE_LIMIT_ERROR_MESSAGE,
} from "utils/networkErrors";
// styling
import { CustomSection, SectionHeader } from "./MyBillingsStyling";
// custom components
import PaymentMethodList from "./PaymentMethodList";
import InvoiceList from "./InvoiceList";
import AddPaymentMethodForm from "./AddPaymentMethodForm";
import BillingAddressForm from "./BillingAddressForm";
import VnpayOrders from "./VnpayOrders";

const MyBillings = () => {
  const { t } = useTranslation("my_billing");
  const { data, error, loading } = useQuery(GET_PAYMENT_TYPE);

  if (loading) {
    return (
      <div style={{ marginTop: 64 }}>
        <Alert type="info" message={t("Loading...")} />
      </div>
    );
  }

  if (error || !data?.me) {
    const description = isRateLimitError(error?.networkError)
      ? RATE_LIMIT_ERROR_MESSAGE
      : "We couldn't load your billing details. Please wait a moment and try again.";

    return (
      <div style={{ marginTop: 64 }}>
        <Alert type="error" message={t(description)} />
      </div>
    );
  }

  const {
    me: { paymentType },
  } = data;
  const isVnpay = paymentType === "vnpay";

  const renderComponents = () => {
    if (isVnpay) {
      return <VnpayOrders />;
    }
    if (!isVnpay) {
      return (
        <div>
          <CustomSection>
            <SectionHeader>{t("MY PAYMENT METHODS")}</SectionHeader>
            <PaymentMethodList />
          </CustomSection>
          <AddPaymentMethodForm />

          <BillingAddressForm />

          <InvoiceList />
        </div>
      );
    }
    return null;
  };

  return <div>{renderComponents()}</div>;
};

export default MyBillings;
